import { Inject } from '@odinjs/odin';
import { AutocompleteAPI, FormAPI } from '@philips-internal/oswald-ui-components';
import { Value } from '@philips-internal/oswald-ui-core';
import Controller, { OnBeforeCancel, OnBeforeSubmit, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import BaseController from '../../../../controllers/BaseController';
import { FragmentNames, ReverseEnteralNutritionAliases } from '../../../../codegen';
import { ReasonType } from '../enteral-nutrition/enteral-nutrition-type';
import { MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import ReverseLastEvent from '../reverse-last-event/reverse-last-event';

@Controller({ component: ReverseEnteralNutritionAliases.REVERSE_ENTERAL_NUTRITION_LAYOUT, fragment: FragmentNames.REVERSE_ENTERAL_NUTRITION })
export default class ReverseTpnController extends BaseController {

  @Inject(ReverseEnteralNutritionAliases.FORM_REASON)
  private formApi!: FormAPI;

  @Inject(ReverseEnteralNutritionAliases.AUTOCOMPLETE_REASON_LIST)
  private reasonAutocompleteApi!: AutocompleteAPI;

  @OnMount(ReverseEnteralNutritionAliases.REVERSE_ENTERAL_NUTRITION_LAYOUT)
  handleMountLayout(): void {
    ReverseLastEvent.handleMountLayout(this);
  }

  @OnMount(ReverseEnteralNutritionAliases.FETCH_REASON)
  handleFetchReasonMount(event: MountEvent): void {
    ReverseLastEvent.fetchReasonMount(event, this);
  }

  @OnBeforeCancel(ReverseEnteralNutritionAliases.FORM_REASON)
  handleCancelForm(): void {
    applicationContext.popNavigationItem();
  }

  @OnBeforeSubmit(ReverseEnteralNutritionAliases.FORM_REASON)
  handleSubmitForm(): void {
    this.reverse();
  }

  private reverse(): void {
    const reasonSelected = this.reasonAutocompleteApi.getValue() as unknown as ReasonType;
    const {
      encounterId,
      sequenceNumber,
      prescriptionNumber,
      solutionType
    } = this.historyService.getCurrentRouteParams();

    const body = {
      encounterNumber: Number(encounterId),
      prescriptionNumber: Number(prescriptionNumber),
      reasonSequenceNumber: reasonSelected?.sequenceNumber,
      situationSolutionType: Number(solutionType),
      solutionNumber: Number(sequenceNumber),
    } as Record<string, Value>;

    ReverseLastEvent.callEndPoint(this.formApi, body, this);
  }

}
